const reservationsEN = {
  'reservations.reservations': 'Reservations',
  'reservations.settings': 'Settings',
  'reservations.reservations-settings': 'Reservations Settings',
  'reservations.online-reservations-waitlist-settings': 'Online Reservations & Waitlist Settings',
  'reservations.enable-in-house-reservations': 'Enable In-House Reservations and Waitlist',
  'reservations.always-enabled': 'This is always enabled for all shifts.',
  'reservations.online-reservations-waitlist': 'Online Reservations Waitlist',
  'reservations.online-reservations-waitlist-description':
    'Allow guests to add themselves to a Reservation Waitlist if their preferred booking time is unavailable. You must contact these guests to inform them if their booking request can be accepted.',
  'reservations.discover-online': 'Discover Online',
  'reservations.discover-online-description':
    'Guests can search for your restaurant on TouchBistro Dine and book a table through Reserve with Google.',
  'reservations.enable-walk-in-waitlist': 'Enable Online Walk-In Waitlist',
  'reservations.enable-walk-in-waitlist-description':
    'Reserve with Google allows guests to join your waitlist online and be notified of their place in line. This applies to all shifts.',
  'reservations.minimum': 'Minimum',
  'reservations.maximum': 'Maximum',
  'reservations.min-party-size': 'Minimum Party Size',
  'reservations.max-party-size': 'Maximum Party Size',
  'reservations.save': 'Save',
  'reservations.tb-dine-page': 'TB Dine Page',
  'reservations.customize-tb-dine-page': 'Customize your TB Dine Page',
  'reservations.fill-out-restaurant-profile':
    'Fill out your restaurant profile with information that guests will use to....',
  'reservations.view-restaurant-profile': 'View Restaurant Profile',
  'reservations.view-tb-dine-page': 'View TB Dine Page',
  'reservations.settings-updated-success': 'Your settings have benn successfully updated.',
  'reservations.availability-planning': 'Availability Planning',
  'reservations.overrides': 'Overrides',
  'reservations.overrides-name': 'Override Name',
  'reservations.overrides-description':
    'Create Shifts Overrides when you need to change your schedule settings on days that are not part of your typical schedule.',
  'reservations.override-create-new-button': 'Create New Override',
  'reservations.service-period': 'Service Period',
  'reservations.shifts': 'Shifts',
  'reservations.shifts-management': 'Shifts Management',
  'reservations.shifts-management-description':
    'Create and manage your recurring or one-time Shifts. Set Shifts time, Table Availability, Pacing and Turn Times and schedule each Shift on the 7 Day Recurring Schedule table above.',
  'reservations.create-new-shift': 'Create New Shift',
  'reservations.shift-name': 'SHIFT NAME',
  'reservations.shift-start-and-end-time': 'START & END TIME',
  'reservations.no-existing-shifts': 'You currently have no Shifts to be displayed.',
  'reservations.closures': 'Closures',
  'reservations.closures-description':
    'Block booking for specific upcoming dates or date ranges. Closures will turn off all Online and In House availability and will cancel any pre-booked reservations for those dates.',
  'reservations.closures-create-button': 'Create New Closure',
  'reservations.closures-name': 'Closure Name',
  'reservations.closures-sp': 'Service Period',
  'reservations.closures-type': 'Closure Type',
  'reservations.empty-setting-message': 'You currently have no {{type}} to be displayed.',
  'reservations.none': 'None',
  'reservations.7_days_recurring_schedule': '7 Days Recurring Schedule',
  'reservations.7_days_recurring_schedule.info':
    'Preview and schedule recurring Shifts for each Day of the Week and Service Period (SP).',
  'reservations.sp_1': 'SP 1',
  'reservations.sp_2': 'SP 2',
  'reservations.monday': 'monday',
  'reservations.tuesday': 'tuesday',
  'reservations.wednesday': 'wednesday',
  'reservations.thursday': 'thursday',
  'reservations.friday': 'friday',
  'reservations.saturday': 'saturday',
  'reservations.sunday': 'sunday',
  'reservations.create_new_shift': 'Create New Shift',
  'reservations.edit_shift': 'Edit Shift',
  'reservations.step_of_total': 'STEP {{current}}/{{total}}',
  'reservations.shift_details': 'Shift Details',
  'reservations.shift_details.description':
    'Specify the shift name and when you would like the shift to occur.',
  'reservations.shift_name': 'Shift Name',
  'reservations.max_n_chars': 'Maximum {{limit}} characters',
  'reservations.first_seating': 'First Seating',
  'reservations.last_seating': 'Last Seating',
  'reservations.availability': 'Availability',
  'reservations.availability.description':
    'Specify how the system will manage online reservations.',
  'reservations.restrict_reservations_to_waitlist':
    'Restrict Online Reservations to be Waitlist Only',
  'reservations.restrict_reservations_to_waitlist.description':
    'If enabled, guests will only be able to add themselves to waitlist using TB Dine and the booking widget on your website for the days this shift is scheduled.',
  'reservation.note_bold': 'Note:',
  'reservation.restrict_note_online_reservation_waitlist_link_text': 'Online Reservation Waitlist',
  'reservation.restrict_note_description_test': 'must be turned ON to use this setting.',
  'reservations.table_availability': 'Table Availability',
  'reservations.table_availability.description':
    'Select the floor plans you want available during your shift. Click “Edit Table Availability” to manage the availabilities of tables and combinations within a floor plan.',
  'reservations.floor_plan_name': 'Floor Plan Name',
  'reservations.max_capacity': 'Max Capacity',
  'reservations.available_capacity': 'Available Capacity',
  'reservations.min_party': 'Min Party',
  'reservations.max_party': 'Max Party',
  'reservations.online_and_in_house': 'Online & In House',
  'reservations.in_house_only': 'In House Only',
  'reservations.online_only': 'Online Only',
  'reservations.walk_in_only': 'Walk-in Only',
  'reservations.availability_empty_content':
    'There are no Floor Plans with Tables created for your Venue. To assign Tables that can be reserved for the Shift, you should have at least one Floor Plan created and Tables added to it.',
  'reservations.edit_table_availability': 'Edit Table Availablity',
  'reservations.edit_table_availabilities': 'Edit Table Availabilities',
  'reservations.go_to_floor_plan': 'Go to Floor Plan',
  'reservations.pacing': 'Pacing',
  'reservations.pacing.description':
    'Pacing allows you to control the maximum number of parties and guests that can book reservations every 15 minutes. Applies to Online & In House bookings for this shift.',
  'reservations.time': 'Time',
  'reservations.max_number_parties': 'Max Number of Parties',
  'reservations.max_number_guests': 'Max Number of Guests',
  'reservations.same_pacing': 'Same pacing all shift for every 15 minute interval',
  'reservations.no_limit': 'No Limit',
  'reservations.turn_times': 'Turn Times',
  'reservations.turn_times.description': 'Specify the expected turn times for each party size.',
  'reservations.party_size': 'Party Size',
  'reservations.expected_time': 'Expected Time (HH / MM)',
  'reservations.party_size.guests': '{{size}} Guests',
  'reservations.hours': 'hour(s)',
  'reservations.min': 'min',
  'reservations.item_created': '"{{item_name}}" has been successfully created.',
  'reservations.item_updated': '"{{item_name}}" has been successfully updated.',
  'reservations.duration': 'Duration',
  'reservations.back_to_create_shift': 'Back to Create New Shift',
  'reservations.select_floorplan_to_edit': 'Select floor plan to edit',
  'reservations.table_and_combinations': 'Table / Combinations',
  'reservations.table_priority': 'Table Priority',
  'reservations.min_seats': 'Min Seats',
  'reservations.max_seats': 'Max Seats',
  'reservations.table_type': 'Table Type',
  'reservations.adult_only': 'Adult Only',
  'reservations.hidden_overlap_shifts_info':
    'Shifts that overlap with the timing of your other service period are not available.',
  'reservations.table_availability_confirmation_dialog.title':
    'Are you sure you want to leave this page without applying your changes?',
  'reservations.table_availability_confirmation_dialog.discard': 'Discard Changes',
  'reservations.table_availability_confirmation_dialog.apply': 'Apply Changes',
  'reservations.select_floor_plan': 'Select Floor Plan',
  'reservations.no_floor_plan_selected': 'You currently have no Floor Plan selected.',
  'reservations.create_new_closure': 'Create New Closure',
  'reservations.edit_closure': 'Edit Closure',
  'reservations.create_new_override': 'Create New Override',
  'reservations.edit_override': 'Edit Override',
  'reservations.back_to_availability_planning': 'Back to Availability Planning',
  'reservations.closure_details': 'Closure Details',
  'reservations.override_details': 'Override Details',
  'reservations.override_shift_name': 'Shift',
  'reservations.closure_name': 'Closure Name',
  'reservations.override_reason': 'Reason',
  'reservations.optional_field': '(Optional)',
  'reservations.closure_applies': 'Applies',
  'reservations.closure_frequency.once': 'Once',
  'reservations.closure_frequency.weekly': 'Weekly',
  'reservations.closure_frequency.daily': 'Daily',
  'reservations.when': 'When',
  'reservations.select_dates': 'Select Dates',
  'reservations.service_period': 'Service Period',
  'reservations.closure_type': 'Closure Type',
  'reservations.edit_multiple_selections': 'Edit Multiple Selections',
  'reservations.edit_tables_with_quantity': 'Editing {{number}} tables and table combinations.',
  'reservations.mixed': 'Mixed',
  'reservation.shift': 'shift',
  'reservations.closure': 'closure',
  'reservations.override': 'override',
  'reservations.confirmation_modal.simple.title':
    'Are you sure you want to delete this {{item_type}}?',
  'reservations.confirmation_modal.simple.title2': 'Deleting {{item_type}} can not be undone.',
  'reservations.confirmation_modal.message':
    'Are you sure you want to delete this {{item_type}}: {{item_name}} ?',
  'reservations.confirmation_modal.title':
    'Are you sure you want to delete the "{{item_name}}" {{item_type}}?',
  'reservations.action_create.success': 'Your {{item_type}} has been created.',
  'reservations.action_update.success': 'Your {{item_type}} has been updated.',
  'reservations.action_delete.success': 'Your {{item_type}} has been deleted.',
  'reservations.action_delete.failure': 'Could not delete {{item_type}}: {{item_name}}',
  'reservations.online_booking': 'Online Booking',
  'reservations.general_settings': 'General Settings',
  'reservations.website_widgets': 'Website Widgets',
  'reservations.booking_widgets': 'Booking Widgets',
  'reservations.reserve_with_google': 'Reserve with Google',
  'reservations.available_through': 'Available through',
  'reservations.channel.widgets': 'Website Widgets',
  'reservations.channel.tb_dine': 'TouchBistro Dine',
  'reservations.channel.booking': 'Online Booking Page',
  'reservations.channel.rwg': 'Reserve with Google',
  'reservations.online_booking_window': 'Online Booking Window',
  'reservations.online_booking_window.description':
    'How far in advance will guests be able to reserve online?',
  'reservations.online_booking_page': 'Online Booking Page',
  'reservations.online_booking_page_link': 'Online Booking Page Link',
  'reservations.online_booking_page_description':
    'Link guests to your TouchBistro Reservations Online Booking Page so they can easily reserve a table or join your waitlist.',
  'reservations.online_booking_page_copy.part_1':
    'This page is created for you using information you provide. The information (such as hours of operation, address, contact information, and more) can be updated by visiting the ',
  'reservations.online_booking_page_copy.part_2': ' area of your account.',
  'reservations.venue_info': 'Venue Info',
  'reservations.tbdine_profile_page': 'TouchBistro Dine Profile Page',
  'reservations.tbdine_profile_page_copy.part_1':
    'Your profile is created for you using information you provide. The information (such as hours of operation, address, contact information, and more) can be updated by visiting the ',
  'reservations.tbdine_profile_page_copy.part_2': ' area of your account.',
  'reservations.diner_notes': 'Diner Notes',
  'reservations.diner_notes.description':
    'Use diner notes to communicate important information to guests who reserve or join the waitlist online.',
  'reservations.diner_notes.en_message.placeholder': 'Enter Message',
  'reservations.diner_notes.en_message.error': 'Oops! The character limit is 4000.',
  'reservations.minors': 'Minors',
  'reservations.minors.description':
    'Turn this on if you want guests to indicate there are minors in their party.',
  'reservations.venue.name': 'Venue: {{venue_details}} (Total)',
  'reservations.closure.full': 'Full',
  'reservations.closure.partial': 'Partial',
  'reservations.frequency.every': 'Every',
  'reservations.frequency.everyday': 'Everyday from',
  'reservations.from': 'from',
  'reservations.booking_window_unit.minute': 'Minutes',
  'reservations.booking_window_unit.hour': 'Hours',
  'reservations.booking_window_unit.day': 'Days',
  'reservations.booking_window_unit.week': 'Weeks',
  'reservations.booking_window_unit.year': 'Years',
  'reservations.select_shift_placeholder': 'Select Shift',
  'reservations.enter_override_reason_placeholder': 'Enter an Override reason',
  'reservations.select_frequency_placeholder': 'Select Frequency',
  'reservations.select_service_period_placeholder': 'Select Service Period',
  'reservations.rwg.description.part_1':
    'TouchBistro and Google drive more bookings together by making it easy to book online using Google Search and Maps.',
  'reservations.rwg.online_walk_in_waitlist': 'Online Walk-In Waitlist',
  'reservations.rwg.online_walk_in_wailist.description':
    "Allow guests to join the Reserve with Google walk-in waitlist before they arrive. They'll even be automatically notified of their place in line.",
  'reservations.rwg.note': 'Note',
  'reservations.rwg.note.description':
    " must be turned ON to use Reserve with Google's Walk-in Waitlist.",
  'reservations.integration': 'Integration',
  'reservations.rwg': 'Reserve with Google',
  'reservations.examples': 'Examples',
  'reservations.reserve_table': 'Reserve a Table',
  'reservations.join_waitlist': 'Join Waitlist',
  'reservations.reserve_table_join_waitlist': 'Reserve a Table & Join Waitlist',
  'reservations.on_search': 'On Search',
  'reservations.on_maps': 'On Maps',
  'reservations.on_booking_page': 'Booking Page',
  'reservations.on_join_waitlist_page': 'Join Waitlist Page',
  'reservations.widget_location': 'Location',
  'reservations.widget_location_title_default': 'Select Venues',
  'reservations.widget_location_title': '{{count}} {{venue}} Selected',
  'reservations.widget_language': 'Widget Language',
  'reservations.widget_type': 'Widget Type',
  'reservations.widget_style': 'Widget Style',
  'reservations.widget_type.row': 'Row',
  'reservations.widget_type.col': 'Column',
  'reservations.widget_type.block': 'Block',
  'reservations.widget_style.default': 'Default',
  'reservations.widget_style.branded': 'Branded',
  'reservations.booking_widget.descr_1':
    "Easily embed the online booking form directly on your restaurant's website using a booking widget.",
  'reservations.booking_widget.descr_2':
    "Choose the style (or styles) you prefer, then copy and paste the widget code below into your website's HTML code.",
  'reservations.note': 'Note',
  'reservations.booking_widget.descr_3.1':
    'To customize the branding of your Booking Widgets, go to the ',
  'reservations.branding': 'Branding',
  'reservations.booking_widget.descr_3.2': ' area of Venue Info.',
  'reservations.booking_widget_missing_location.descr_1':
    'Select at least 1 Location to generate a preview of your Booking Widget',
  'reservations.booking_widget_missing_location.descr_2':
    'Select at least 1 location to generate your Booking Widget Code',
  'reservations.heads_up': 'Heads up',
  'reservations.heads_up.descr_1': 'Your ',
  'reservations.heads_up.descr_2': ' needs to be set up before guests can book online.',
  'reservations.widget_branding_cta.descr_1':
    'Did you know you can apply your brand colors to Booking Widgets?',
  'reservations.widget_branding_cta.descr_2.1': 'Visit the ',
  'reservations.widget_branding_cta.descr_2.2': ' area of Venue Info to set this up.',
  'reservations.here': 'here',
  'reservations.widget_branding_block.descr_1': 'Click ',
  'reservations.widget_branding_block.descr_2': ' to customize Widgets with your brand colors.',
  'reservations.booking_widget_code': 'Booking Widget Code',
  'reservations.booking_iframes': 'Booking Iframes',
  'reservations.booking_iframes.descr':
    "An iframe can be used to include the TouchBistro Dine booking website on your restaurant's website so diners can book a reservation without having to leave your website. To use an iframe copy and paste the iframe code below into your website's HTML code.",
  'reservations.booking_iframe_code': 'Booking Iframe Code',
  'reservations.sp_cutoff_time': 'SP1 / SP2 Cutoff Time',
  'reservations.communications': 'Communications',
  // errors
  'reservations.error.max-party-size-limit': 'Maximum party size is 10',
  'reservations.error.min-max-party-size':
    'Minimum Party size can not be more than Maximum Party Size',
  'reservations.error.max-min-party-size':
    'Maximum Party size can not be less than Minimum Party Size',
  'reservations.error.character_limit': '{{field}} must be up to {{limit}} characters long.',
  'reservations.error.shift_name_unique':
    'This Shift name is already in use. Please enter a unique Shift name.',
  'reservations.error.first_last_seating_same': 'First and Last Seating time cannot be the same.',
  'reservations.error.scheduling_conflict_header':
    'Oops! These seating times overlap with another scheduled shift:',
  'reservations.error.scheduling_conflict_footer':
    'To continue, please update the seating times or remove this shift from the recurring schedule.',
  'reservations.error.override_conflict_header':
    'Oops! This overlaps with another scheduled shift/override:',
  'reservations.error.override_conflict_footer':
    'To continue, please make sure no other shifts/overrides exist on the selected date(s) and Service Period(s)',
  'reservations.error.shiftwide_pacing_invalid_combo':
    'Please enter a valid max parties/max guests combination.',
  'reservations.error.zero_turn_time': 'Expected turn time cannot be less than 15 minutes.',
  'reservations.error.parties_exceed_guests':
    'Number of parties cannot exceed the number of guests.',
  'reservations.error.zero_parties_and_guests':
    'When the number of parties is 0, the number of guests has to be 0.',
  'reservations.error.zero_guest_and_parties':
    'When the number of guests is 0, the number of parties has to be 0',
  'reservations.error.guests_less_than_parties':
    'Number of guests cannot be less than number of parties.',
  'reservations.error.min_max': 'Oops! Minimum should be less than Maximum.',
  'reservations.error.max_duration': 'Oops! 1 year is the limit.',
  'reservations.error.empty_shift_override_selection':
    'Please select a Shift in order to create an Override.',
  'reservations.error.empty_frequency_closure_selection':
    'Please choose how often you want your Closure applied.',
  'reservations.error.empty_frequency_override_selection':
    'Please choose how often you want your Override applied.',
  'reservations.error.empty_period_override_selection':
    'Please choose the Service Period you want your Override applied.',
  'reservations.error.conflict_more': '+ {{count}} more',
  'reservations.shifts_delete.tooltip.inuse': '(In use)',
  'reservations.communications_guest_facing.title': 'Guest Facing Communications',
  'reservations.communications_staff_facing.title': 'Staff Facing Communications',
  'reservations.communications.guest_facing.appliesToTitle': 'Applies to:',
  'reservations.communications.guest_facing.attendanceConfirmationRequestDescription':
    'Send guests a confirmation request based on the settings below.',
  'reservations.communications.guest_facing.attendanceConfirmationRequestTitle':
    'Attendance Confirmation Request',
  'reservations.communications.guest_facing.autoMessageDescription':
    'Automatically send messages that confirm bookings and notify customers when their table is ready. To preview this and other messages that TouchBistro Reservations sends to your guests, click <1><2>here<2></1>.',
  'reservations.communications.guest_facing.chooseWhenMessageIsSent':
    'Choose when the message is sent',
  'reservations.communications.guest_facing.chooseWhichPartySizesReceiveConfirmation':
    'Choose which party sizes will receive a confirmation',
  'reservations.communications.guest_facing.partySizes.all': 'All party sizes',
  'reservations.communications.guest_facing.partySizes.group': 'Parties of {{partySize}} or more',
  'reservations.communications.guest_facing.requestTime.before': '{{hours}}h before',
  'reservations.communications.guest_facing.requestTime.hours': '{{hours}} hours',
  'reservations.communications.guest_facing.requestTime.never': 'Never',
  'reservations.communications.guest_facing.sendConfirmationRequestNotificationTitle':
    'Send Confirmation Request Notification:',
  'reservations.communications.table_is_ready_sms_title': '”Table is Ready” SMS',
  'reservations.communications.table_is_ready_sms_description':
    'Personalize the SMS guests receive when their table is ready. The default message below will be sent if not edited.',
  'reservations.communications.table_is_ready_sms_msg_default':
    'Your table is now ready at {VenueName}, please return to the host stand within 5 minutes, thank you!',
  'reservations.communications.table_is_ready_sms_msg_example':
    'Personalize your message with the variables below, they’ll auto-fill with guest details. Example: Your table for {PartySize} is now ready at {VenueName}.',
  'reservations.communications_token_name': {
    first_name: 'First Name',
    last_name: 'Last Name',
    venue_name: 'Venue Name',
    party_size: 'Party Size',
  },
  'reservations.communications_message_preview_title': 'Preview',
  'reservations.communications_message_preview': {
    title: 'Message',
    msg_time: 'NOW',
    msg_footer_text: 'Reply 1: Cancel',
  },
  'reservations.communications.reset_button': 'Reset',
  'reservations.communications.restore_default': 'Restore default SMS',
  'reservations.communications.guest_facing.templated_message_title': 'Templated Messages',
  'reservations.communications.guest_facing.templated_message_description':
    'Templated messages make it easy to quickly respond to common questions or share important information with guests.',
  'reservations.communications.guest_facing.templated_message.delete_dialog_confirmation':
    'Delete Template',
  'reservations.communications.guest_facing.templated_message.delete_dialog_title':
    'Are you sure you want to delete the Templated Message titled "{{title}}"',
  'reservations.communications.guest_facing.templated_message.delete_dialog_subtitle':
    'This action is irreversible',
  'reservations.communications.guest_facing.templated_message_delete_success':
    '"{{title}}" has been deleted.',
  'reservations.communications.guest_facing.create_templated_message_button': 'Create New Template',
  'reservations.communications.guest_facing.template_table.row_1': 'Message Title',
  'reservations.communications.guest_facing.template_table.row_2': 'Message',
  'reservations.communications.guest_facing.empty_table_message':
    'There are no templated messages yet.',
  'communication_name_validation.required': 'A message title is required.',
  'communication_name_validation.max_length': 'The title exceeds the {{length}} character limit.',
  'communication_message_validation.max_length':
    'This message exceeds the {{length}} character limit.',
  'communication_message_validation.required': 'A message template is required.',
  'communication_template.create_title': 'Create New Templated Message',
  'communication_template.edit_title': 'Edit Templated Message',
  'communication_template.back_to_guest_communications_settings_link':
    'Back to Guest Communications Settings',
  'communication_template.templated_message_details_title': 'Templated Message Details',
  'communication_template.message_title': 'Message Title',
  'communication_template.optional': 'Optional',
  'communication_template.message_title_placeholder': 'Enter the templated message title',
  'communication_template.message_title_description':
    'Message titles help hosts identify which message template to use. Titles are only visible to staff, not guests.',
  'communication_template.message_body_title': 'Templated Message',
  'communication_template.message_body_description':
    'Personalize your message with the variables below, they’ll auto-fill with guest details. Example: Hi {FirstName}, your table for {PartySize} at {ReservationTime} is confirmed!',
  'communication_template.message_body_placeholder': 'Write the message guests will receive.',
  'communication_template.save_success_message': 'Templated message saved successfully.',
  'communication_template.save_error_message': 'There was an error saving the templated message.',
  'reservations.communications.booking_notification.title':
    'Configure which staff receive notifications:',
  'reservations.communications.booking_notification.description':
    'We only show staff members with a valid email address.',
  'reservations.communications.custom_staff_notifications.title':
    'Configure custom recipients for notifications:',
  'reservations.communications.daily_summary_email.title': 'Daily Summary Email',
  'reservations.communications.daily_summary_email.description':
    'Choose if and when staff members receive a daily summary email of upcoming reservations and waitlist guests.',
  'reservations.communications.receive_daily_email_options.morning_only': 'Morning only',
  'reservations.communications.receive_daily_email_options.morning_late_afternoon':
    'Morning and late afternoon',
  'reservations.communications.online_booking_notification.title': 'Online Booking Notification',
  'reservations.communications.online_booking_notification.description':
    'Get notified when a guest creates, modifies, or cancels their booking online.',
  'reservations.communications.when_online_reservation_created':
    'When a new online reservation is made',
  'reservations.communications.when_online_reservation_modified':
    'When a guest modifies their reservation online',
  'reservations.communications.when_online_reservation_cancelled':
    'When a guest cancels their reservation online',
  'reservations.communications.validation.at_least_one_receiver':
    'Please select at least one receiver.',
  'reservations.communications.validation.email_notification_required_with_custom_email':
    'Enable at least one email notification for custom email recipients.',
  'reservations.communications.validation.sms_notification_required_with_custom_sms':
    'Enable at least one SMS notification for custom phone recipients.',
  'reservations.communications.guest_facing.save_success_message':
    'Communication settings saved successfully.',
  'reservations.communications.staff_facing.save_success_message':
    'Notification settings saved successfully.',
  'reservations.communications.staff_facing.custom_email_fields': 'Add Custom Email',
  'reservations.communications.staff_facing.custom_phone_fields': 'Add Custom Phone',
  'reservations.communications.validation.custom_receiver_contact_required':
    'A contact is required.',
  'reservations.communications.validation.custom_receiver_contact_email_invalid':
    'Please enter a valid email address.',
  'reservations.communications.validation.custom_receiver_contact_phone_invalid':
    'Please enter a valid phone number.',
  'reservations.communications.validation.custom_receiver_label_required': 'A name is required.',
  'reservations.communications.staff_facing.non_staff_label': '{{main_label}}',
}

export default reservationsEN
